import * as React from 'react';
import classnames from 'classnames';
import { createPortal } from 'react-dom';
import { Popper } from 'react-popper';
import { useTooltip } from './TooltipContext.js';

const TooltipContent = ({ id , placement ='top' , boundariesElement ='scrollParent' , children , theme , renderInPortal ,  })=>{
    const { isActive , setIsActive , isTouch  } = useTooltip();
    const [tooltipHovered, setTooltipHovered] = React.useState(false);
    const handleMouseOver = React.useCallback(()=>{
        !isTouch && setTooltipHovered(true);
    }, [
        isTouch
    ]);
    const handleMouseLeave = React.useCallback(()=>{
        !isTouch && setTooltipHovered(false);
    }, [
        isTouch
    ]);
    const tooltipContainer = classnames('tooltip tooltip__container', {
        'tooltip--black': theme === 'black',
        'tooltip--grey': theme === 'grey',
        'tooltip--white': theme === 'white'
    });
    const popper = /*#__PURE__*/ React.createElement(Popper, {
        placement: placement,
        positionFixed: true,
        modifiers: {
            offset: {
                offset: '0px, 10px'
            },
            preventOverflow: {
                enabled: true,
                boundariesElement,
                padding: 10
            }
        }
    }, ({ ref , style , placement: computedPlacement  })=>/*#__PURE__*/ React.createElement("div", {
            ref: ref,
            className: tooltipContainer,
            style: style
        }, /*#__PURE__*/ React.createElement("div", {
            "aria-hidden": !isActive,
            "data-placement": computedPlacement,
            className: "tooltip__message",
            onMouseOver: handleMouseOver,
            onMouseLeave: handleMouseLeave,
            onFocus: ()=>null
            ,
            onBlur: ()=>setIsActive(false)
        }, children))
    );
    return /*#__PURE__*/ React.createElement("div", {
        "aria-live": "polite",
        id: id
    }, (isActive || tooltipHovered) && (renderInPortal ? /*#__PURE__*/ createPortal(popper, document.body) : popper));
};

export { TooltipContent };
//# sourceMappingURL=TooltipContent.js.map
